var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2442_56)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30 0H0V30H30V0Z",
    fill: "#D71924"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2205 9.17115C23.4985 8.31295 22.1656 7.96289 19.6201 7.96289H10.3797C7.77594 7.96289 6.42045 8.33554 5.70123 9.24921C5 10.1401 5 11.4526 5 13.2693V16.7318C5 20.2512 5.832 22.0381 10.3797 22.0381H19.6201C21.8276 22.0381 23.0508 21.7292 23.8422 20.9719C24.6537 20.1952 25 18.9271 25 16.7318V13.2693C25 11.3535 24.9457 10.0331 24.2205 9.17115ZM17.8401 15.4786L13.6441 17.6715C13.5503 17.7206 13.4477 17.7449 13.3452 17.7449C13.2292 17.7449 13.1135 17.7137 13.011 17.6516C12.8179 17.5346 12.7001 17.3254 12.7001 17.0997V12.7279C12.7001 12.5026 12.8176 12.2935 13.0103 12.1765C13.203 12.0595 13.4426 12.0515 13.6426 12.1553L17.8386 14.3342C18.0521 14.445 18.1861 14.6654 18.1865 14.9059C18.1867 15.1465 18.0532 15.3672 17.8401 15.4786Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2442_56"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.886a234dd6e23491c3cf79d45b2eec72.svg";
export { ForwardRef as ReactComponent };